import { useTranslation } from 'react-i18next';
import { Severity } from '@/rule/domain/Rule.ts';

export const useSeverityText = (severity: Severity): string => {
  const { t } = useTranslation('rule');

  switch (severity) {
    case Severity.CRITICAL:
      return t('rule.severity.critical');
    case Severity.HIGH:
      return t('rule.severity.high');
    case Severity.MEDIUM:
      return t('rule.severity.medium');
    case Severity.LOW:
      return t('rule.severity.low');
    case Severity.INFO:
      return t('rule.severity.info');
  }
};
